import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { RendezVous } from '../../Pages/Public/RendezVous.js';
import { RendezVousPersonnage } from '../../Pages/Public/RendezVousPersonnage.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteRendezVous = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    const [ren, setRen] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataRen = await fetch(`${backend}/nav/characters`, GetHeaders(guest));
            const ren = await dataRen.json();
            setRen(ren);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/rendez-vous" element={<RendezVous navParks={navParks} />} />
                {ren.map((el, i) => {
                    return (<Route path={el.route} element={<RendezVousPersonnage navParks={navParks} id={el.id} slug={el.slug} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}